<template>
	
	<div class="wizard-component select-field">
		<p class="subject">{{ subject }}</p>
		<div class="select-container">
			<select>
				<option v-for="option in selectFields">{{ option.item }}</option>
			</select>
			<span class="icon">
				<svg xmlns="http://www.w3.org/2000/svg" width="15" height="7" viewBox="0 0 20 11.97">
				  <path class="fill-purple" d="M3260.4,2087.48l-7.88,7.95a2.067,2.067,0,0,1-1.54.59,2.045,2.045,0,0,1-1.53-.59l-7.88-7.95a2.046,2.046,0,0,1,0-2.88,2.022,2.022,0,0,1,2.86,0l6.55,6.61,6.56-6.61a2.022,2.022,0,0,1,2.86,0A2.046,2.046,0,0,1,3260.4,2087.48Z" transform="translate(-3241 -2084.03)"/>
				</svg>
			</span>
		</div>

	</div>

</template>


<script>
	import {mapGetters} from 'vuex';
    import {store} from '../../../store/index'
    export default {
	

		data: () => ({
			subject: 'Prepaid rent',
			selectFields: [

				{
					item: 'None'
				},
				{
					item: '1 month'
				},
				{
					item: '2 months'
				},
				{
					item: '3 months'
				}
			]		

		})

	}
</script>


<style></style>